import { render, staticRenderFns } from "./DeclarRecord.vue?vue&type=template&id=3ccbe594&scoped=true"
import script from "./DeclarRecord.vue?vue&type=script&lang=js"
export * from "./DeclarRecord.vue?vue&type=script&lang=js"
import style0 from "./DeclarRecord.vue?vue&type=style&index=0&id=3ccbe594&prod&lang=css"
import style1 from "./DeclarRecord.vue?vue&type=style&index=1&id=3ccbe594&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccbe594",
  null
  
)

export default component.exports